import { gql } from '@apollo/client';

export const GET_WELDERS = gql`
  query GetWelders($filters: PeopleFilterInput) {
    people(filters: $filters) {
      list {
        id
        name
      }
    }
  }
`;
